<template>
    <prep-adherence>
        <p class="headline text-xs-center">Let’s Review</p>
        <p>
            We have learned a lot in this activity, like that you’re committed to doing what you can to protect yourself from getting HIV and that taking PrEP is important to you because:
        </p>
        <ul>
            <li v-for="motivator in prepChangeMotivators" :key="motivator.id">{{ motivator.userEntered ? motivator.response : motivator.text }}</li>
        </ul>
        <br />
        <p>
            We were reminded that taking PrEP a minimum of 4 days a week and up to everyday is the most reliable way to protect ourselves against HIV when having sex. In order to support you taking PrEP at least 4 days a week, we identified
            strategies that can help remind you to take your PrEP. These strategies include:
        </p>
        <ul>
            <li v-for="strategy in prepStrategies" :key="strategy.id">{{ strategy.userEntered ? strategy.response : strategy.text }}</li>
        </ul>
        <br />
        <p>
            You’ve got it! Way to go!!
        </p>
    </prep-adherence>
</template>

<script>
    import { filter } from 'lodash';

    export default {
        computed: {
            prepChangeMotivators() {
                return filter(this.$store.get('prepMotivatorsRevisited'), 'selected');
            },
            prepStrategies() {
                return filter(this.$store.get('prepRegularStrategiesRevisited'), 'selected');
            }
        }
    };
</script>
